import { Component, Output, EventEmitter, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FileHolder } from 'angular2-image-upload';
import { ArchivoCotizacion } from '../../../../interfaces/archivo-cotizacion';
import { CotizacionService } from '../../../../providers/cotizacion.service';

@Component({
  selector: 'app-subir-archivos-cotizacion',
  templateUrl: './subir-archivos-cotizacion.component.html',
  styleUrls: ['./subir-archivos-cotizacion.component.scss']
})
export class SubirArchivosCotizacionComponent {
  archivos: ArchivoCotizacion[] = <ArchivoCotizacion[]>[];
  archivoUploadEstados = [];
  archivoUploadProgressValue: number;
  archivoUploadProgressLimit: number;
  cargandoArchivos: boolean = false;
  extensions: string[] = ['pdf', 'jpg', 'jpeg', 'png'];

  IdCotizacion: number | string;
  @Output() onArchivoInput = new EventEmitter(); // datos del formulario cambian
  @Output() onCargandoArchivos = new EventEmitter<boolean>(); // carngado 
  @Output() onArchivosSubidos = new EventEmitter<boolean>(); // carngado 
  @Input() mostrarSubir: boolean = true;

  constructor(
    private cotizacionService: CotizacionService,
    private _sanitizer: DomSanitizer
  ) { }

  onInput(): void {
    this.archivoUploadEstados = [];
    this.onArchivoInput.emit();
  }

  getSecureUrl(url) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${url})`);
  }

  setCargando(cargando: boolean): void {
    this.onCargandoArchivos.emit(cargando);
  }

  onArchivoCargado(fileHolder: FileHolder): void {
    this.archivos.push(<ArchivoCotizacion>{
      src: fileHolder.src,
      nombre: fileHolder.file.name
    });
  }

  onArchivoQuitado(fileHolder: FileHolder) {
    this.archivos.forEach((archivo: ArchivoCotizacion, index: number) => {
      if (archivo.nombre == fileHolder.file.name && archivo.src == fileHolder.src) {
        this.archivos.splice(index, 1);
      }
    });
  }

  public onSubirArchivos(): void {
    this.setCargando(true);
    this.cargandoArchivos = true;

    // Subir archivos
    this.archivoUploadEstados = [];
    this.archivoUploadProgressValue = 0;
    this.archivoUploadProgressLimit = this.archivos.length;
    if (this.archivos.length > 0) {
      this.enviarArchivoAlSv(this.archivos[0]);
    } else {
      this.cargandoArchivos = false;
      this.archivosCargados();
    }
  }

  enviarArchivoAlSv(archivo: ArchivoCotizacion): void {
    this.cotizacionService.subirArchivosCotizacion(
      this.IdCotizacion,
      [archivo]
    ).subscribe(
      respuesta => {
        if (respuesta) {
          this.archivoUploadEstados.push({
            nombre: archivo.nombre,
            estado: respuesta.estado,
            mensaje: respuesta.mensaje,
            src: archivo.src
          });
        }

        this.archivoEnviado();
      },
      error => {
        this.archivoUploadEstados.push({
          nombre: archivo.nombre,
          estado: 2,
          mensaje: error,
          src: archivo.src
        });
        this.archivoEnviado();
      }
    );
  }

  archivoEnviado(): void {
    this.archivos.splice(0, 1);
    if (this.archivos.length > 0) {
      this.archivoUploadProgressValue = 100 * (this.archivoUploadProgressLimit - this.archivos.length) / this.archivoUploadProgressLimit;
      this.enviarArchivoAlSv(this.archivos[0]);
    } else {
      this.cargandoArchivos = false;
      this.archivosCargados();
    }
  }

  archivosCargados(): void {
    if (!this.cargandoArchivos) {
      this.setCargando(false);

      // Le damos al list de estados unos milisegundos para que se dibuje
      setTimeout(() => {
        this.onArchivosSubidos.emit();
      }, 10);
    }
  }

  /**
   * Retorna true si hay errores durante la carga de archivos
   */
  hasErrors(): boolean {
    return this.archivoUploadEstados.filter(archivoSubido => archivoSubido.estado != 1).length != 0;
  }
}
